const ValidateConfig = {
	required: {
	  required: true
	},
	no_required: {
	  required: false
	},
	coin_market_rate: {
	  required: true
	},
	coin: {
	  required: true
	},
	amount: {
	  required: true
	},
	commission: {
	  required: true
	},
	withdraw_judgement: {
	  required: true,
	  isInt: {}
	},
	staff_username: {
	  required: false,
	  isAlphanumeric: '',
	  isLength: { min: 6, max: 18 }
	},
	staff_username_required: {
	  required: true,
	  isAlphanumeric: '',
	  isLength: { min: 6, max: 18 }
	},
	staff_password: {
	  required: false,
	  isAlphanumeric: '',
	  isLength: { min: 10, max: 32 },
	  matches: ['^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z\\d]{10,32}$', 'i']
	},
	staff_password_required: {
	  required: true,
	  isAlphanumeric: '',
	  isLength: { min: 10, max: 32 },
	  matches: ['^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\\d)[a-zA-Z\\d]{10,32}$', 'i']
	},
	staff_permission: {
	  required: true,
	  isInt: {}
	},
	hash: {
	  required: true
	},
	uuid: {
	  required: true
	},
	code: {
	  required: true
	}
  }
  
  const DisplaySetting = {
	ログイン: {
	  post_authin: {}
	},
	ユーザ一覧取得: {
	  get_users: {}
	},
	ユーザ詳細: {
	  get_users_id: {}
	},
	ユーザ削除: {
	  delete_users_id: {}
	},
	ユーザ認証変更: {
	  put_users_id_verify: {}
	},
	ユーザウォレット一覧取得: {
	  get_users_id_wallets: {}
	},
	ユーザ入出金履歴一覧取得: {
	  get_users_id_histories: {}
	},
	ユーザ入金: {
	  post_users_id_deposit: {}
	},
	ユーザ出金: {
	  post_users_id_withdraw: {}
	},
	ウィズドロー申請一覧取得: {
	  get_withdraws: {}
	},
	ウィズドロー審査: {
	  put_withdraws: {}
	},
	SCPの設定取得: {
	  get_settings_scp: {}
	},
	SCPの設定更新: {
	  put_settings_scp: {}
	},
	コミッションの設定取得: {
	  get_settings_commissions: {}
	},
	コミッションの設定更新: {
	  put_settings_commissions: {}
	},
	アフェリエイトの設定取得: {
	  get_settings_affiliates: {}
	},
	アフェリエイトの設定更新: {
	  put_settings_affiliates: {}
	},
	スタッフ一覧取得: {
	  get_staffs: {}
	},
	スタッフ新規登録: {
	  post_staffs: {}
	},
	ログインスタッフのパスワード変更: {
	  put_staffs_password: {}
	},
	スタッフ詳細: {
	  get_staffs_id: {}
	},
	スタッフ更新: {
	  put_staffs_id: {}
	},
	スタッフ削除: {
	  delete_staffs_id: {}
	},
	スタッフパスワードリセット: {
	  put_staffs_id_password: {}
	}
  }
  
  const ApiSetting = {
	get_users_id: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	delete_users_id: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	put_users_id_verify: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	get_users_id_wallets: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	get_users_id_histories: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	post_users_id_deposit: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  },
	  coin: {
		label: 'コイン',
		validate: 'coin'
	  },
	  amount: {
		label: '入金額',
		validate: 'amount'
	  },
	  commission: {
		label: '手数料',
		validate: 'commission'
	  },
	  memo: {
		label: 'メモ',
		validate: 'no_required'
	  }
	},
	post_users_id_withdraw: {
	  uuid: {
		label: 'ユーザID',
		validate: 'uuid',
		type: 'url'
	  },
	  coin: {
		label: 'コイン',
		validate: 'coin'
	  },
	  amount: {
		label: '出金額',
		validate: 'amount'
	  },
	  commission: {
		label: '手数料',
		validate: 'commission'
	  },
	  memo: {
		label: 'メモ',
		validate: 'no_required'
	  }
	},
	put_withdraws: {
	  uuid: {
		label: 'ウィズドローID',
		validate: 'uuid',
		type: 'url'
	  },
	  judgement: {
		label: '審査結果',
		validate: 'withdraw_judgement'
	  }
	},
	put_settings_scp: {
	  buy_rate: {
		label: '買いレート',
		validate: 'coin_market_rate'
	  },
	  sell_rate: {
		label: '売りレート',
		validate: 'coin_market_rate'
	  }
	},
	put_settings_commissions: {
	  coin: {
		label: 'コイン',
		validate: 'coin'
	  },
	  buy: {
		label: '買い手数料',
		validate: 'commission'
	  },
	  sell: {
		label: '売り手数料',
		validate: 'commission'
	  },
	  deposit: {
		label: '入金手数料',
		validate: 'commission'
	  },
	  withdraw: {
		label: '出金手数料',
		validate: 'commission'
	  }
	},
	put_settings_affiliates: {
	  coin: {
		label: 'コイン',
		validate: 'coin'
	  },
	  buy: {
		label: '買い手数料',
		validate: 'commission'
	  },
	  sell: {
		label: '売り手数料',
		validate: 'commission'
	  },
	  deposit: {
		label: '入金手数料',
		validate: 'commission'
	  },
	  withdraw: {
		label: '出金手数料',
		validate: 'commission'
	  }
	},
	post_staffs: {
	  username: {
		label: 'スタッフ名',
		validate: 'staff_username_required'
	  },
	  permission: {
		label: '権限',
		validate: 'staff_permission'
	  }
	},
	put_staffs_password: {
	  new_password: {
		label: '新しいパスワード',
		validate: 'staff_password_required'
	  },
	  current_password: {
		label: '現在のパスワード',
		validate: 'staff_password_required'
	  }
	},
	get_staffs_id: {
	  uuid: {
		label: 'スタッフID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	put_staffs_id: {
	  uuid: {
		label: 'スタッフID',
		validate: 'uuid',
		type: 'url'
	  },
	  username: {
		label: 'スタッフ名',
		validate: 'staff_username_required'
	  },
	  permission: {
		label: '権限',
		validate: 'staff_permission'
	  }
	},
	delete_staffs_id: {
	  uuid: {
		label: 'スタッフID',
		validate: 'uuid',
		type: 'url'
	  }
	},
	put_staffs_id_password: {
	  uuid: {
		label: 'スタッフID',
		validate: 'uuid',
		type: 'url'
	  }
	}
  }
  
  module.exports = {
	ValidateConfig,
	DisplaySetting,
	ApiSetting
  }
  